// 根据id返回购物车数据
function findCartId(id) {
  return new Promise((resolve, reject) => {
    try {
      // 尝试从localStorage中获取购物车数据
      const cartDataStr = JSON.parse(localStorage.getItem("cartData"));
      if (cartDataStr?.data) {
        const cartData = cartDataStr.data;
        const foundItem = cartData.find((item) => item.id == id); // 使用不同的变量名
        if (foundItem) {
          // 如果找到了商品，则resolve
          resolve(foundItem);
        } else {
          // 如果没有找到商品，返回一个错误
          reject(new Error("Item not found in cart"));
        }
      }
    } catch (error) {
      // 捕获任何可能出现的错误，并reject
      reject(error);
    }
  });
}

// 计算购物车总价
function cartSUM() {
  var sum = 0;
  const cartDataStr = JSON.parse(localStorage.getItem("cartData"));
  if (cartDataStr?.data) {
    const cartData = cartDataStr.data;
    cartData.find((item) => {
      if (item._fabric_product_price != undefined) {
        sum += parseInt(item._fabric_product_price);
      } else {
        sum += item.line_total;
      }
    });
    return parseInt(sum);
  }
  return 0;
}

function updateCardList(referList, targetList) {
  $.each(referList, function (i, item) {
    $.each(Object.keys(item), function (i, itemC) {
      $.each(targetList, function (i, data) {
        if (data.id == item.id) {
          data[itemC] = item[itemC];
        }
      });
    });
  });
  return targetList;
}

function productListChange(ele, imgList, meetingDataList = dataList) {
  var $productList = $(ele);
  $productList.each(function (i, ele) {
    if ($(ele).attr("data-list") != null) {
      const modelList = $(ele).attr("data-list").split(",");
      const sameList = meetingDataList.filter(function (item) {
        return modelList.includes(item.id);
      });
      productCard(
        ele,
        listOrderByArr(sameList, modelList),
        { showType: [] },
        "Unlined",
        imgList
      );
    }
  });
}

var tagList = ["bestseller", "premiere", "editors-pick", "new-arrival"];
function productCard(
  ele,
  list,
  filterInitList = { showType: [] },
  lining = "Unlined",
  imgList = []
) {
  var str = [];
  for (var i = 0; i < list.length; i++) {
    if (imgList.length > 0) {
      list = updateCardList(imgList, list);
    }
    str.push(`<div data-src="${list[i].imgSrc}" class="item `);
    if (filterInitList.showType.length > 0) {
      $.each(Object.keys(list[i]), function (j, itemType) {
        if (filterInitList.showType.includes(itemType)) {
          var id = "";
          if (list[i][itemType] instanceof Array) {
            if (list[i][itemType][z] != "") {
              var item = " ";
              for (var z = 0; z < list[i][itemType].length; z++) {
                item += `${itemType.replace(/\//g, "-")}_${list[i][itemType][
                  z
                ].replace(/ /g, "_")}`;
                item += " ";
              }
              id = item;
            }
          } else {
            if (list[i][itemType] != "") {
              id = `${itemType.replace(/\//g, "-")}_${list[i][itemType].replace(
                / /g,
                "_"
              )}`;
              id += " ";
            }
          }
          str.push(id);
        }
      });
    }
    str.push(`" data-id="${list[i].id}">`);
    str.push(
      `<a href="${list[i].ProductUrl}${
        lining ? `&lining=${lining}` : ""
      }" class="itemContainer">`
    );
    str.push(`<div class="productImg">`);
    str.push(`<img src="${list[i].imgSrc}">`);
    // str.push(
    //   `<img class="hoverImg" src="${
    //     list[i].hoverImg == undefined || list[i].hoverImg == ""
    //       ? list[i].imgSrc
    //       : list[i].hoverImg
    //   }">`
    // );
    str.push(`<img class="hoverImg" src="${list[i].imgSrc}">`);
    if (list[i]["tags"] != undefined) {
      const sameList = list[i]["tags"].filter(function (item) {
        return tagList.includes(item.slug);
      });
      if (sameList.length > 1) {
        console.log(list[i].ProductUrl);
      }

      if (list[i].isNewArrival) {
        str.push(`<div class="tag" type="New Arrival"></div>`);
      } else if (sameList.length > 0) {
        str.push(`<div class="tag" type="${sameList[0].name}"></div>`);
      }
    }
    str.push(`</div>`);

    str.push('<div class="productDetails">');
    str.push(`<div class="productFabrics">${list[i].Fabrics.join(" , ")}`);
    // str.push(`<div class="productColorList">`);
    // for (var j = 0; j < list[i]["_fabric_color"].length; j++) {
    //   if (j >= 4) {
    //     break;
    //   }
    //   str.push(
    //     `<img src="${list[i]["_fabric_color"][j].imgSrcF}" name="${list[i].ProductUrl}`
    //   );
    //   if (lining) {
    //     str.push(`&lining=${lining}`);
    //   }
    //   str.push(
    //     `&step_color=${list[i]["_fabric_color"][j].title}" data-src="${list[i]["_fabric_color"][j].imgSrc_n}" />`
    //   );
    // }
    // if (list[i]["_fabric_color"].length > 4) {
    //   str.push(
    //     `+${list[i]["_fabric_color"].length - 4} COLOR${
    //       list[i]["_fabric_color"].length - 4 > 1 ? "S" : ""
    //     }`
    //   );
    // }
    // str.push(`</div>`);
    str.push(`</div>`);
    if (list[i].subheading != undefined) {
      str.push(`<div class="subheading">${list[i].subheading}</div>`);
    }
    // str.push('<div class="productPrice">');
    // if (list[i].Sale) {
    //   str.push(
    //     `<span class="oldPrice">$${Math.round(list[i].oldPrice)}</span>`
    //   );
    // } else {
    //   str.push(`<span>$${Math.round(list[i].oldPrice)}</span>`);
    // }
    // if (list[i].Sale) {
    //   str.push(`<span class="discount">${list[i].Sale}</span>`);
    // }
    // if (list[i].Sale) {
    //   str.push(
    //     `<span class="newPrice">$${Math.round(list[i].newPrice)}</span>`
    //   );
    // }
    // str.push("</div>");
    // if (list[i].extra) {
    //   str.push(`<div class="extra">LIMITED TIME OFFER: ${list[i].extra} OFF</div>`);
    // }

    // if (list[i].AllCategory != undefined) {
    //   if (!list[i].AllCategory.includes("No Sale Coupons")) {
    //     str.push(
    //       `<div class="extra">LIMITED TIME OFFER: EXTRA 10% OFF</div>`
    //     );
    //   }
    // }

    str.push(`<h2 class="title" style="display: none;">${list[i].title}</h2>`);
    str.push(`</div>`);
    str.push(`</a>`);
    str.push(`</div>`);
  }
  if ($(ele).find(".itemCard").length > 0) {
    $(ele).find(".item:not(.itemCard)").remove();
    $(ele).find(".itemCard").after(str.join(""));
  } else {
    $(ele).html(str.join(""));
  }
  $.each($(ele).find(".productImg"), function (i, item) {
    const ImgSrcWidth = $(item).find("> img:not(.hoverImg)").width();
    if (ImgSrcWidth) {
      $(item).css("height", `${ImgSrcWidth}px`);
    }
  });

  $(window).resize(function () {
    $.each($(ele).find(".productImg"), function (i, item) {
      const ImgSrcWidth = $(item).find("> img:not(.hoverImg)").width();
      if (ImgSrcWidth) {
        $(item).css("height", `${ImgSrcWidth}px`);
      }
    });
  });

  $(ele)
    .find("div.productFabrics > .productColorList img")
    .hover(
      function () {
        var item = $(this).closest(".item");
        item
          .find(".productImg img:not(.hoverImg)")
          .attr("src", $(this).attr("data-src"));
      },
      function () {
        var item = $(this).closest(".item");
        item
          .find(".productImg img:not(.hoverImg)")
          .attr("src", item.attr("data-src"));
      }
    );

  $(ele)
    .find("div.productFabrics > .productColorList img")
    .on("click", function (event) {
      event.preventDefault();
      // 阻止事件冒泡
      event.stopPropagation();
      window.open($(this).attr("name"));
    });
}
function cardChange(e, productlist) {
  var $productList = $(e);
  $productList.each(function (i, ele) {
    var str = [];
    list = productlist.filter(function (item) {
      return item.id == $(ele).find(".cardItem").attr("data-id");
    });
    if (list.length > 0) {
      for (var i = 0; i < list.length; i++) {
        str.push(`<div class="productDetails">`);
        str.push(`<div class="productFabrics">${list[i].Fabrics}`);
        str.push(`<div class="productColorList">`);
        for (var j = 0; j < list[i]["_fabric_color"].length; j++) {
          if (j >= 4) {
            break;
          }
          str.push(
            `<a href="${list[i].ProductUrl}&step_color=${list[i]["_fabric_color"][j].title}">
              <img src="${list[i]["_fabric_color"][j].imgSrcF}" data-src="${list[i]["_fabric_color"][j].imgSrc_n}" /></a>`
          );
        }
        if (list[i]["_fabric_color"].length > 4) {
          str.push(
            `+${list[i]["_fabric_color"].length - 4} COLOR${
              list[i]["_fabric_color"].length - 4 > 1 ? "S" : ""
            }`
          );
        }
        str.push(`</div>`);
        str.push(`</div>`);
        if (list[i].subheading != undefined) {
          str.push(`<div class="subheading">${list[i].subheading}</div>`);
        }
        str.push(`<div class="productPrice">`);
        if (list[i].Sale) {
          str.push(
            `<span class="oldPrice">$${Math.round(list[i].oldPrice)}</span>`
          );
        } else {
          str.push(`<span>$${Math.round(list[i].oldPrice)}</span>`);
        }
        if (list[i].Sale) {
          str.push(`<span class="discount">${list[i].Sale}</span>`);
        }
        if (list[i].Sale) {
          str.push(
            `<span class="newPrice">$${Math.round(list[i].newPrice)}</span>`
          );
        }
        str.push(`</div>`);
        if (list[i].AllCategory != undefined) {
          if (!list[i].AllCategory.includes("No Sale Coupons")) {
            str.push(
              `<div class="extra">LIMITED TIME OFFER: EXTRA 10% OFF</div>`
            );
          }
        }
        str.push(`
          <h2 class="title" style="display: none;">${list[i].title}</h2>`);
        str.push(`</div>`);
      }
      if ($(ele).find(".cardItem .productDetails").length > 0) {
        $(ele).find(".cardItem .productDetails").remove();
      }
      $(ele)
        .find(".cardItem")
        .html(str.join(""))
        .attr("href", list[0].ProductUrl);
    }
  });
}
// 默认根据id去重
function removeDuplicates(List, keys = "id") {
  const uniqueData = {};
  List.forEach((item) => {
    if (!uniqueData[item[keys]]) {
      uniqueData[item[keys]] = item;
    }
  });
  return Object.values(uniqueData);
}

var topEvent = scrollTop > 0 ? ["header.header", "countdown-timer-bar.countdown-timer-bar"] : ["header.header"];
// 页面滚动使指定元素置顶
function windowScrollTop(event, topEventList = [], fevent = "html,body") {
  if (topEventList.length == 0) {
    topEventList = topEvent;
  }
  var item = event,
    headerHeight = 0;
  const scrollTop = item.offset().top;
  for (var i = 0; i < topEventList.length; i++) {
    headerHeight += parseInt($(topEventList[i]).outerHeight() || 0);
  }
  const feventScrollTop = fevent == "html,body" ? 0 : $(fevent).scrollTop();
  $(fevent).animate(
    {
      scrollTop: Math.floor(
        scrollTop - headerHeight - $(fevent).offset().top + feventScrollTop
      ),
    },
    150
  );
}
// 页面滚动使指定元素居中
function windowScrollToMiddle(
  event,
  topEventList = topEvent,
  fevent = "html,body"
) {
  var $target = event;
  var headerHeight = 0;

  for (var i = 0; i < topEventList.length; i++) {
    headerHeight += parseInt($(topEventList[i]).outerHeight() || 0);
  }

  var viewportHeight = $(window).height();
  var targetHeight = $target.outerHeight();
  var targetPosition = $target.offset().top - headerHeight;
  // 指定元素中心点居中
  // var scrollToPosition = targetPosition - (viewportHeight - targetHeight) / 2;
  // 指定元素顶部居中
  var scrollToPosition = targetPosition - viewportHeight / 2;

  $(fevent).animate(
    {
      scrollTop: scrollToPosition,
    },
    150
  );
}
function windowScrollHeight(topEventList = []) {
  if (topEventList.length == 0) {
    topEventList = topEvent;
  }
  var headerHeight = 0
  for (var i = 0; i < topEventList.length; i++) {
    headerHeight += parseInt($(topEventList[i]).outerHeight() || 0);
  }
  return headerHeight;
}

// 判断元素是否完整在可视窗口内
// element: 元素类名; top:元素于顶部的距离
function isElementInViewport(element, top = 0) {
  var rect = element.getBoundingClientRect();
  return (
    rect.top >= top &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

function arrRandom(arr, count) {
  var newArr = [];
  // 检查数量是否足够
  if (arr.length >= count) {
    // 随机化数组
    for (let i = arr.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [arr[i], arr[j]] = [arr[j], arr[i]];
    }
    newArr = arr.slice(0, count);
  } else {
    newArr = arr;
  }
  return newArr;
}

function pakoUnlock(data) {
  return JSON.parse(
    pako.inflateRaw(base64ToUint8Array(data), {
      to: "string",
    })
  );
}

// uint8array转为base64字符串
function uint8arrayToBase64(u8Arr) {
  let CHUNK_SIZE = 0x8000; //arbitrary number
  let index = 0;
  let length = u8Arr.length;
  let result = "";
  let slice;
  while (index < length) {
    slice = u8Arr.subarray(index, Math.min(index + CHUNK_SIZE, length));
    result += String.fromCharCode.apply(null, slice);
    index += CHUNK_SIZE;
  }
  // web image base64图片格式: "data:image/png;base64," + b64encoded;
  // return  "data:image/png;base64," + btoa(result);
  return window.btoa(result);
}
// base64字符串转为uint8array数组
function base64ToUint8Array(base64String) {
  let padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  let base64 = (base64String + padding).replace(/\-/g, "+").replace(/_/g, "/");
  let rawData = window.atob(base64);
  let outputArray = new Uint8Array(rawData.length);
  for (var i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

function listOrderByArr(oldData, orderBy) {
  var idMap = {};
  oldData.forEach((item, index) => {
    idMap[item.id] = index;
  });

  var sortedData = [];
  orderBy.forEach((id) => {
    if (idMap[id] !== undefined) {
      sortedData.push(oldData[idMap[id]]);
    }
  });
  return sortedData;
}

function copyBtn(copyText, copyBtn) {
  const defaultBtn = $(copyBtn).html();
  $(copyBtn).on("click", function () {
    if (navigator.clipboard) {
      navigator.clipboard
        .writeText(copyText)
        .then(function () {
          $(copyBtn).append("COPIED");
          setTimeout(() => {
            $(copyBtn).html(defaultBtn);
          }, 3000);
        })
        .catch(function (err) {
          // 复制失败
          console.error(err);
        });
    }
  });
}

function categoriesNum(categories) {
  const cartDataStr = JSON.parse(localStorage.getItem("cartData"));
  var quantity = 0;
  if (cartDataStr?.data) {
    cartDataStr.data.filter((item) => {
      if (
        item.categories.includes(categories) &&
        !item.color.toLowerCase().includes("all color")
      ) {
        quantity += parseInt(item.quantity);
      }
    });
  }
  return quantity;
}

function categoriesNumById(id) {
  const cartDataStr = JSON.parse(localStorage.getItem("cartData"));
  var quantity = 0;
  if (cartDataStr?.data) {
    cartDataStr.data.filter((item) => {
      if (
        item.product_id == id &&
        !item.color.toLowerCase().includes("all color")
      ) {
        quantity += parseInt(item.quantity);
      }
    });
  }
  return quantity;
}

function productListCardChange(ele, productList) {
  var $productList = $(ele);
  $productList.each(function (i, ele) {
    if ($(ele).attr("data-list") != null) {
      const modelList = jQuery.unique($(ele).attr("data-list").split(","));
      const sameList = productList.filter(function (item) {
        return modelList.includes(item.id);
      });
      productCard(
        ele,
        listOrderByArr(sameList, modelList),
        {
          showType: [],
        },
        "Unlined"
      );
    }
  });
}

// 防抖函数
function debounce(func, wait) {
  let timeout;
  return function (...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      func.apply(context, args);
    }, wait);
  };
}

// 节流函数
function throttle(func, limit) {
  let lastFunc;
  let lastRan;
  return function () {
    const context = this,
      args = arguments;
    if (!lastRan) {
      func.apply(context, args);
      lastRan = Date.now();
    } else {
      clearTimeout(lastFunc);
      lastFunc = setTimeout(function () {
        if (Date.now() - lastRan >= limit) {
          func.apply(context, args);
          lastRan = Date.now();
        }
      }, limit - (Date.now() - lastRan));
    }
  };
}

function elementCenter(ele) {
  var elementOffset = $(ele).offset(); // 获取元素相对于文档的偏移
  var elementWidth = $(ele).outerWidth();
  var elementHeight = $(ele).outerHeight();

  // 计算元素中心相对于视窗的位置
  var centerX = elementOffset.left + elementWidth / 2 - $(window).scrollLeft();
  var centerY = elementOffset.top + elementHeight / 2 - $(window).scrollTop();

  return {
    top: centerY,
    left: centerX,
  };
}

function preventScroll(event) {
  event.preventDefault();
}
